export default "__VITE_ASSET__1eb8699f__"